export const saveActivities = (activities) =>{
    const activitiesList = []
        for (var i=0;i<activities.length-1;i++){
            var nameActivity ="--"
            if(activities[i].name){
                nameActivity = activities[i].name
            }
            
            if (activities[i].type === "Run"){
                if (activities[i].average_heartrate){
                    if (activities[i].total_elevation_gain){
                        var up = activities[i].total_elevation_gain
                    }
                    else{
                        var up = 0
                    }
                    ///subtype is calculated to the backend
                    var entryForSave = {id:activities[i].id,
                        name:nameActivity,
                        activity_type:activities[i].type,
                        distance:activities[i].distance,
                        duration:activities[i].elapsed_time/60,
                        date:activities[i].start_date_local,
                        hr:activities[i].average_heartrate,
                        up:up,
                        down:0
                    }
                    console.log(nameActivity)
                    activitiesList.push(entryForSave)
                }
                else{
                    if (activities[i].total_elevation_gain){
                        var up = activities[i].total_elevation_gain
                    }
                    else{
                        var up = 0
                    }
                    
                    var entryForSave = {id:activities[i].id,
                        activity_type:activities[i].type,
                        distance:activities[i].distance,
                        duration:activities[i].elapsed_time/60,
                        date:activities[i].start_date_local,
                        hr:0,
                        up:up,
                        down:0
                    }

                    activitiesList.push(entryForSave)

                }
                
            }
            else{
                if (activities[i].average_heartrate){
                    if (activities[i].total_elevation_gain){
                        var up = activities[i].total_elevation_gain
                    }
                    else{
                        var up = 0
                    }
                    
                    var entryForSave = {id:activities[i].id,
                        activity_type:activities[i].type,
                        distance:activities[i].distance,
                        duration:activities[i].elapsed_time/60,
                        date:activities[i].start_date_local,
                        hr:activities[i].average_heartrate,
                        up:up,
                        down:0
                    }

                    activitiesList.push(entryForSave)
                }
                else{
                    if (activities[i].total_elevation_gain){
                        var up = activities[i].total_elevation_gain
                    }
                    else{
                        var up = 0
                    }
                    
                    var entryForSave = {id:activities[i].id,
                        activity_type:activities[i].type,
                        distance:activities[i].distance,
                        duration:activities[i].elapsed_time/60,
                        date:activities[i].start_date_local,
                        hr:0,
                        up:up,
                        down:0
                    }

                    activitiesList.push(entryForSave)

                }
            }
        }
        if (activitiesList.length>1){
            return(activitiesList)
        }
        else{
            alert('Didnt find running Activites')
        }
}


